import Api from "./baseApi";
import bonusType from "@/lib/bonusType";

const state = {
  all: [],
  registerUsersGroupTotal: [],
  registerUsersGroup: [],
  bonusesGroup: [],
  playersOutDetail: [],
  userTotals: [],
  userTotalByChips: [],
  activeUsers:[],
  player: {},
};
const getters = {
  player: (state) => {
    return state.player;
  },
};
const actions = {
  getGroupSnIdUserTotal: async (context) => {
    let d = (await Api.get(`/admin/users/getGroupSnIdUserTotal`)).data;
    context.commit("getGroupSnIdUserTotal", d);
  },
  getActiveUsers: async (context) => {
    let d = (await Api.get(`/admin/users/getActiveUsers`)).data;
    context.commit("getActiveUsers", d);
  },
  getUserTotalByChip: async (context) => {
    let d = (await Api.get(`admin/users/getUserTotalByChip`)).data;
    context.commit("getUserTotalByChip", d);
  },
  getRegisterUserCount: async (context, params) => {
    let query = {
      size: 0,
      query: {
        bool: {
          must: [
            {
              range: {
                registerDate: {
                  gte: params.startDate,
                },
              },
            },
          ],
        },
      },
      aggs: {
        group_by_user: {
          terms: {
            size: 1000,
            field: "deviceInfo.os.keyword",
            missing: "N/A",
          },
          aggs: {
            platformInfo: {
              terms: {
                field: "platformInfo.snId",
              },
            },
          },
        },
      },
    };
    let d = (
      await Api.post(`https://api.slotbase.co/search/search/log_users`, query)
    ).data;
    context.commit("getRegisterUserCount", d);
  },
  getBonuesCount: async (context, params) => {
    let query = {
      size: 0,
      query: {
        bool: {
          must: [
            {
              range: {
                createdTime: {
                  gte: params.startDate,
                },
              },
            },
          ],
        },
      },
      aggs: {
        group_by_user: {
          terms: {
            size: 1000,
            field: "type",
            missing: 0,
          },
          aggs: {
            total: {
              sum: {
                field: "chip",
              },
            },
          },
        },
      },
    };
    let d = (
      await Api.post(
        `https://api.slotbase.co/search/search/log_bonuses`,
        query
      )
    ).data;
    context.commit("getBonuesCount", d);
  },
};
const mutations = {
  getGroupSnIdUserTotal(state, data) {
    state.userTotals = data;
  },
  getActiveUsers(state, data) {
    state.activeUsers = data;
  },
  getUserTotalByChip(state, data) {
    data.forEach((item) => {
      item.leftTime = Math.round(
        (new Date().getTime() - item.playerOnline.l * 1000) / 1000
      );
    });

    state.userTotalByChips = data;
  },
  getRegisterUserCount(state, player) {
    state.registerUsersGroupTotal = [];
    player.aggregations.group_by_user.buckets.forEach((val) => {
      val.platformInfo.buckets.forEach((element) => {
        let data = state.registerUsersGroupTotal.find(
          (m) => m.key == element.key
        );
        if (data != null) {
          data.value += element.doc_count;
        } else
          state.registerUsersGroupTotal.push({
            key: element.key,
            value: element.doc_count,
          });
      });
    });

    state.registerUsersGroup = player.aggregations.group_by_user.buckets;
  },
  getBonuesCount(state, player) {
    state.bonusesGroup = player.aggregations.group_by_user.buckets;
    state.bonusesGroup.map((b) => {
      b.key = bonusType.find((c) => c.key == b.key).value;
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
